export default function PHP_get_proto_info() {
  return (
    <div>
      <h1>PHP_get_proto_info</h1>
    </div>
  );
}
